<h3>
  <strong> {{ 'Mobile.ResourceCount' | translate }}: {{ resourceCount }} </strong>
</h3>
